export enum GammaColorType {
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
}
